import { Injectable } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { RequestService } from '@commonServices/request.service';
import { CompanySpecificRoleAssignmentInfoDto, GlobalRoleAssignmentInfosDto, OnBoardingDto, RoleAssignmentDto, RoleAssignmentInfoDto, RoleAssignmentState } from '@interfaces/HttpClient/AccountApiModels';
import { AccountLanguage } from '@interfaces/HttpClient/AccountApiPublicModels';
import { AdministratorService } from '@services/administrator.service';


@Injectable()
export class OrcaAdminUserAdministrationService {

	constructor(
		private administratorService: AdministratorService,
		private requestService: RequestService
	) { }

	// ===== CREATE =====
	public async createRole(email: string, language: AccountLanguage, roleAssignmentDto: RoleAssignmentDto) {
		return this.mapOnBoardingDtoToRoleAssignmentViewModel(await this.administratorService.createOnBoarding(email, language, roleAssignmentDto))
	}

	private mapOnBoardingDtoToRoleAssignmentViewModel(onBoarding: OnBoardingDto): RoleAssignmentInfoDto {
		if (isNullish(onBoarding)) {
			return null;
		}
		return {
			onBoardingId: onBoarding.id,
			email: onBoarding.emailAddress,
			expirationUtc: onBoarding.roleAssignments[0].expirationUtc,
			validSinceUtc: onBoarding.created,
			role: onBoarding.roleAssignments[0].role,
			state: RoleAssignmentState.Invited,
			canDelete: true,
			canChangeTo: []
		}
	}

	async getRoleAssignmentInfos(): Promise<GlobalRoleAssignmentInfosDto> {
		try {
			return await this.administratorService.getRoleAssignmentInfos()
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}


	// // ===== READ =====
	async getGlobalRoleAssigmentInfos(): Promise<GlobalRoleAssignmentInfosDto | undefined> {
		const globalRoleAssignmentInfos = await this.administratorService.getRoleAssignmentInfos()
		return globalRoleAssignmentInfos;
	}

	async getCompanySpecificRoleAssignmentInfos(): Promise<CompanySpecificRoleAssignmentInfoDto[] | undefined> {
		const companyRoleAssignmentInfoDto = await this.administratorService.getRoleAssignmentInfos()
		return companyRoleAssignmentInfoDto.companySpecificRoleAssignmentInfos;
	}

	// ===== UPDATE =====
	async updateRole(updatedRoleAssignmentDto: RoleAssignmentInfoDto): Promise<RoleAssignmentInfoDto> {
		const confirmedRoleAssignmentInfo = await this.administratorService.updateRoleAssignment(updatedRoleAssignmentDto);
		return confirmedRoleAssignmentInfo
	}

	// ===== DELETE =====
	async deleteRole(role: RoleAssignmentInfoDto) {
		const isOnboarding = !!role.onBoardingId
		const isRoleAssignment = !!role.roleAssignmentId

		if (isOnboarding) {
			await this.administratorService.deleteOnboarding(role.onBoardingId)
		} else if (isRoleAssignment) {
			await this.administratorService.deleteRoleAssignment(role.roleAssignmentId)
		}
	}
}
